import { lazy } from "react";
import type { RouteObject } from "react-router";

const CarRentalIndex = lazy(() => import("./pages/page"));
const Dashboard = lazy(() => import("./pages/dashboard/page"));

// Bookings
const Bookings = lazy(() => import("./pages/bookings/page"));
const BookingNew = lazy(() => import("./pages/bookings/new/page"));
const BookingDetail = lazy(() => import("./pages/bookings/[id]/page"));
const BookingEdit = lazy(() => import("./pages/bookings/[id]/edit/page"));

// Customers
const Customers = lazy(() => import("./pages/customers/page"));
const CustomerDetail = lazy(() => import("./pages/customers/[id]/page"));

// Vehicles
const Vehicles = lazy(() => import("./pages/vehicles/page"));
const VehicleNew = lazy(() => import("./pages/vehicles/new/page"));
const VehicleDetail = lazy(() => import("./pages/vehicles/[id]/page"));
const VehicleEdit = lazy(() => import("./pages/vehicles/[id]/edit/page"));
const VehicleAvailability = lazy(
  () => import("./pages/vehicles/availability/page")
);

// Pickups / Returns / Settings (URL /releases preserved for backward-compat)
const Pickups = lazy(() => import("./pages/pickups/page"));
const PickupDetail = lazy(() => import("./pages/pickups/[id]/page"));
const Returns = lazy(() => import("./pages/returns/page"));
const ReturnDetail = lazy(() => import("./pages/returns/[id]/page"));
const Settings = lazy(() => import("./pages/settings/page"));

// Reports
const Reports = lazy(() => import("./pages/reports/page"));
const ReportBookings = lazy(() => import("./pages/reports/bookings/page"));
const ReportBranches = lazy(() => import("./pages/reports/branches/page"));
const ReportCustomers = lazy(() => import("./pages/reports/customers/page"));
const ReportExecutive = lazy(() => import("./pages/reports/executive/page"));
const ReportFinancial = lazy(() => import("./pages/reports/financial/page"));
const ReportPenalties = lazy(() => import("./pages/reports/penalties/page"));
const ReportRevenue = lazy(() => import("./pages/reports/revenue/page"));
const ReportVehicles = lazy(() => import("./pages/reports/vehicles/page"));

export const carRentalRoutes: RouteObject[] = [
  { index: true, Component: CarRentalIndex },
  { path: "dashboard", Component: Dashboard },

  // Bookings
  { path: "bookings", Component: Bookings },
  { path: "bookings/new", Component: BookingNew },
  { path: "bookings/:id", Component: BookingDetail },
  { path: "bookings/:id/edit", Component: BookingEdit },

  // Customers
  { path: "customers", Component: Customers },
  { path: "customers/:id", Component: CustomerDetail },

  // Vehicles
  { path: "vehicles", Component: Vehicles },
  { path: "vehicles/new", Component: VehicleNew },
  { path: "vehicles/availability", Component: VehicleAvailability },
  { path: "vehicles/:id", Component: VehicleDetail },
  { path: "vehicles/:id/edit", Component: VehicleEdit },

  // Other — "releases" path kept for backward-compat, "pickups" is the
  // preferred path going forward (see issue #420 phase 2).
  { path: "pickups", Component: Pickups },
  { path: "pickups/:id", Component: PickupDetail },
  { path: "releases", Component: Pickups },
  { path: "releases/:id", Component: PickupDetail },
  { path: "returns", Component: Returns },
  { path: "returns/:id", Component: ReturnDetail },
  { path: "settings", Component: Settings },

  // Reports
  { path: "reports", Component: Reports },
  { path: "reports/bookings", Component: ReportBookings },
  { path: "reports/branches", Component: ReportBranches },
  { path: "reports/customers", Component: ReportCustomers },
  { path: "reports/executive", Component: ReportExecutive },
  { path: "reports/financial", Component: ReportFinancial },
  { path: "reports/penalties", Component: ReportPenalties },
  { path: "reports/revenue", Component: ReportRevenue },
  { path: "reports/vehicles", Component: ReportVehicles },
];
